export interface ChatPlan {
  code: string
  custom_page: boolean
  intervalLength: number
  intervalUnit: string
  paypal_enabled: boolean
  setupFee: number
  trialLength: number
  trialUnit: string
  discount: number
  unitAmountNoDiscount: number
  unitAmount: number
  creditsCount: number
  isPopular?: boolean
}

/**
 * Star-credit bundles offered in the purchase paywall (ported from `useAdditionalPlans`).
 * Plan `code`s map to provider plan ids; the source picks them per-domain. These default to
 * the astrologia codes — override here if the target funnel uses a different plan family.
 * TODO(payments): confirm the correct provider plan codes for this project.
 */
const PLAN_CODES = [
  "lpr_astr_3mins_advisor",
  "lpr_astr_8mins_advisor",
  "lpr_astr_15mins_advisor",
  "lpr_astr_30mins_advisor",
]

const BASE_PLANS: Omit<ChatPlan, "code">[] = [
  {
    paypal_enabled: false,
    custom_page: false,
    trialLength: 0,
    trialUnit: "days",
    intervalLength: 1,
    intervalUnit: "days",
    setupFee: 0,
    discount: 0,
    unitAmountNoDiscount: 5.99,
    unitAmount: 5.99,
    creditsCount: 180,
  },
  {
    paypal_enabled: false,
    custom_page: false,
    trialLength: 0,
    trialUnit: "days",
    intervalLength: 1,
    intervalUnit: "days",
    setupFee: 0,
    discount: 30,
    unitAmountNoDiscount: 14.29,
    unitAmount: 9.99,
    creditsCount: 480,
  },
  {
    paypal_enabled: false,
    custom_page: false,
    trialLength: 0,
    trialUnit: "days",
    intervalLength: 1,
    intervalUnit: "days",
    setupFee: 0,
    discount: 50,
    unitAmountNoDiscount: 31.99,
    unitAmount: 15.99,
    creditsCount: 900,
    isPopular: true,
  },
  {
    paypal_enabled: false,
    custom_page: false,
    trialLength: 0,
    trialUnit: "days",
    intervalLength: 1,
    intervalUnit: "days",
    setupFee: 0,
    discount: 70,
    unitAmountNoDiscount: 99.99,
    unitAmount: 29.99,
    creditsCount: 1800,
  },
]

export const liveChatPlans: ChatPlan[] = BASE_PLANS.map((plan, index) => ({
  ...plan,
  code: PLAN_CODES[index] ?? "",
}))

/** Discounted single-bundle offer shown when the user tries to skip the paywall. */
export const specialOfferPlan: ChatPlan = {
  code: "lpr_astr_3mins_advisor_special",
  paypal_enabled: false,
  custom_page: false,
  trialLength: 0,
  trialUnit: "days",
  intervalLength: 1,
  intervalUnit: "days",
  setupFee: 0,
  discount: 0,
  unitAmountNoDiscount: 5.99,
  unitAmount: 2.99,
  creditsCount: 180,
}
